import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Iframe from "react-iframe";
import "./StudentHome.css";
import axios from "axios";
import moment from "moment";

class StudentHome extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      history: null,
      apiError: false
    };
  }

  componentDidMount() {
    axios.get(`/api/student/student/${this.props.user.lcf_id}`)
      .then(data => this.setState({data: data.data[0]}))
      .catch(() => this.setState({apiError: true}));
    axios.get(`api/student/transaction-history/${this.props.user.lcf_id}`)
      .then(result => this.setState({history: result.data}))
      .catch((e) => {this.setState({apiError: true}); console.log("API eror", e)});
  }

  render() {
    return (
      <div style={{ width: "99%" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: "2%" }}>
            <center>
              {this.state.data ? (
                <h1>Hello there {this.state.data.first_name}!</h1>
              ) : (
                <h1>Hello there {this.props.user.email}!</h1>
              )}
              <h3>LCF ID: {this.props.user.lcf_id}</h3>
            </center>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Paper
              elevation={5}
              style={{ border: "", padding: "4%", margin: "3%" }}
            >
              <center>
                <Iframe
                  // style="width: 90%"
                  src="https://calendar.google.com/calendar/embed?title=Legacy%20Calendar&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=b88a8t126lf3cofcti721mu8pc%40group.calendar.google.com&amp;color=%23333333&amp;src=cfmdroilnfj71ep58mjic8bjv0%40group.calendar.google.com&amp;color=%238D6F47&amp;src=60i842s5uglu16too6f0bs5nq0%40group.calendar.google.com&amp;color=%236B3304&amp;src=66tdpj4tskh9o7qdb0n5ffs81k%40group.calendar.google.com&amp;color=%2323164E&amp;src=prbvfdkrlj30d1p4osinnmsqq0%40group.calendar.google.com&amp;color=%232F6309&amp;src=5ukrumpstnq37u91sc23jo3iio%40group.calendar.google.com&amp;color=%23711616&amp;src=f061r68qd6vc7db0l4qi5k0jio%40group.calendar.google.com&amp;color=%2329527A&amp;src=rb038vtg2r577kgn962nlvlru8%40group.calendar.google.com&amp;color=%23B1440E&amp;src=kbkdiah43goo8388rc29f6bk3k%40group.calendar.google.com&amp;color=%23B1365F&amp;src=fargoschools.org_ag5ihl34v5q8l3u50rttd05k24%40group.calendar.google.com&amp;color=%23B1440E&amp;ctz=America%2FChicago"
                  width="100%"
                  height="400"
                  frameborder="0"
                  scrolling="no"
                ></Iframe>
              </center>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={4}>
            <Paper elevation={5} style={{ padding: "4%", margin: "5%" }}>
              <h3>Payment Information</h3>
              <hr></hr>
              {this.state.data && this.state.history ? (
                <>
                  Last Paycheck: ${" "}
                  {this.getLatestTransaction()}
                  {/* need conditional here or wont load*/}
                  {this.state.data.balance_due != 0 && (<>
                    <br />
                    Balance to Pay: $ {this.state.data.balance_due}
                  </>)}
                  <br />
                  Current Savings: ${" "}
                  {this.state.data.total_amount}
                </>
              ) : (
                <>
                  Last Paycheck: $$
                  <br />
                  Current Savings: $$
                </>
              )}
              <br />
              <a href="/#/paststudententries">More Details</a>
            </Paper>
          </Grid>
        </Grid>
        <br/>
        <br/>
      </div>
    );
  }

  getLatestTransaction() {
    for (let i = this.state.history.length - 1; i >= 0; i--) {
      if (this.state.history[i].amount > 0) {
        return this.state.history[i].amount + " on "
          + moment(this.state.history[i].moment).local().format("M/D/YY");
      }
    }
    return "(none)";
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  studentHistory: state.studentHistory.studentHistoryReducer,
  entries: state.students.studententriesadmin,
  students: state.students.studentlist,
});

export default withRouter(connect(mapStateToProps)(StudentHome));
